<template>
    <transition name="fade">
        <div v-if="currentModal"
             v-click-outside="closeModal">
            <div class="modal-container"
                 :style="{ height }">
                <div class="modal-heading">
                    <div v-if="showCloseButton"class="invisible-btn"
                         @click="closeModal">
                        <img src="../../assets/img/svg/down.svg">
                    </div>
                </div>
                <keep-alive>
                    <component
                        :is="currentModal"
                        ref="currentModal"
                        @removeModal="removeModal($event)"
                        @submit="closeModal">
                    </component>
                </keep-alive>
            </div>
        </div>
    </transition>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Modal',

        data() {
            return {
                windowHeight: 0
            }
        },

        directives: { ClickOutside },

        computed: {
            ...mapGetters(['currentModal', 'options']),

            height() {
                let height;
                return  height = this.windowHeight + 'px';
            },
            showCloseButton() {
                if (this.options && this.options.fade) {
                    return false
                }
                return true;
            }
        },

        methods: {
            ...mapActions(['closeModal']),

            onResizeHeight() {
                this.windowHeight = window.innerHeight;
            },

            removeModal(event) {
                /* if(event === 'CustomFormModal') {
                    this.$refs.currentModal.$destroy();
                } */
                this.$children.forEach(el => {
                    if (el.$options.name === 'CustomFormModal') {
                        el.$destroy();
                    }
                })
            }
        },

        mounted() {
            this.onResizeHeight();
            window.addEventListener('resize', this.onResizeHeight);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResizeHeight);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals/Modal.vue